export const SETTINGS_DRAWERS = {
  BUSINESS_HOURS: 'businessHoursDrawer',
  CONTENT_AUTOMATION: 'contentAutomationDrawer',
  PERFORMANCE_ALERT: 'performanceAlertDrawer',
};
